import { useState } from "react";
import {
  WorkPolicyRequest,
  WorkPolicyStage
} from "../../api/work-policy-api.types";
import {
  ActionButton,
  RecoveryPanel
} from "./work-type-management.styles";

export interface WorkPolicyRecoveryState {
  code: string;
  message: string;
  resourceId?: number;
  lastCompletedStage?: WorkPolicyStage;
  retryable: boolean;
  fingerprint?: string;
  request: WorkPolicyRequest;
}

interface WorkPolicySaveRecoveryProps {
  recovery: WorkPolicyRecoveryState | null;
  successMessage: string | null;
  busy: boolean;
  onRetry: () => void;
}

export const WorkPolicySaveRecovery = ({
  recovery,
  successMessage,
  busy,
  onRetry
}: WorkPolicySaveRecoveryProps) => {
  const [detailsExpanded, setDetailsExpanded] = useState(false);
  if (successMessage) {
    return (
      <RecoveryPanel role="status">
        <h3>저장 결과</h3>
        <p>{successMessage}</p>
      </RecoveryPanel>
    );
  }
  if (!recovery) return null;
  return (
    <RecoveryPanel danger role="alert">
      <h3>
        {recovery.code === "WORK_POLICY_NETWORK_UNKNOWN"
          ? "저장 결과를 확인하지 못했습니다"
          : "저장이 일부만 완료되었습니다"}
      </h3>
      <p>{recovery.code === "WORK_POLICY_NETWORK_UNKNOWN" ? "중복 저장을 피하기 위해 서버 상태를 다시 확인한 뒤 재시도하세요." : "완료된 내용은 유지됩니다. 같은 정책으로 남은 저장을 다시 시도할 수 있습니다."}</p>
      {recovery.retryable &&
        recovery.resourceId !== undefined &&
        recovery.lastCompletedStage &&
        recovery.fingerprint && (
          <div>
            <ActionButton type="button" primary disabled={busy} onClick={onRetry}>
              같은 정책으로 다시 시도
            </ActionButton>
          </div>
        )}
      <div>
        <ActionButton type="button" aria-expanded={detailsExpanded} aria-controls="work-policy-recovery-details" onClick={() => setDetailsExpanded(current => !current)}>
          {detailsExpanded ? "오류 세부정보 닫기" : "오류 세부정보 보기"}
        </ActionButton>
      </div>
      {detailsExpanded && (
        <div id="work-policy-recovery-details" role="region" aria-label="오류 세부정보">
          <p>{recovery.message}</p>
          {recovery.resourceId !== undefined && <p>정책 ID: {recovery.resourceId}</p>}
          {recovery.lastCompletedStage && <p>마지막 완료 단계: {recovery.lastCompletedStage}</p>}
          {recovery.fingerprint && <p>지원 코드: {recovery.fingerprint}</p>}
        </div>
      )}
    </RecoveryPanel>
  );
};
